export const catalogSorter = {
  title: "Organizador inteligente de catálogo",
  tabs: {
    manual: "Manual",
    rules: "Reglas",
    ai: "IA",
  },
  info: "Arrastra y suelta para ordenar tus productos como prefieras. El orden se reflejará en tu tienda.",
  updateDisclaimer:
    "El orden se actualiza automáticamente. Última ejecución: {{hour}}",
  preview: "Vista previa",
  apply: "Aplicar",
  applying: "Aplicando...",
  saveSuccess: "Orden del catálogo actualizado correctamente",
  saveError: "No se pudo actualizar el orden del catálogo",
  improveWithAi: "Mejorar el orden de mi catálogo con IA",
  aiDisableHint:
    "Para desactivar la IA, aplica un orden Manual o por Reglas.",
  rules: {
    countVisits: "Más visitados",
    createdAt: "Más recientes",
    totalOrders: "Más vendidos",
    price: "Precio",
  },
  empty: {
    title: "Aún no tienes productos",
    message: "Crea tu primer producto para organizar tu catálogo.",
    button: "Crear producto",
  },
  aiModal: {
    title: "Ordenamiento con IA",
    message:
      "La inteligencia artificial organizará tu catálogo según el comportamiento de tus clientes. El proceso puede tardar unos minutos en reflejarse.",
  },
  acquire: {
    title: "Activa el organizador inteligente",
    description:
      "Ordena tu catálogo de forma manual, por reglas o con inteligencia artificial.",
    cta: "Adquirir complemento",
  },
};
